const prod = {
  JOB_SITE_URL: 'https://job.jobswidget.me',
  APP_SITE_URL: 'https://app.jobswidget.me',
  API_URL: 'https://job.jobswidget.me/api/v1/',
  WEBSOCKET_URL: 'wss://job.jobswidget.me/ws',
};

export { prod as default };
